"use strict";

exports.__esModule = true;
exports.IS_BANNER_ENABLED_DEFAULT = void 0;
var IS_BANNER_ENABLED_DEFAULT = false;
exports.IS_BANNER_ENABLED_DEFAULT = IS_BANNER_ENABLED_DEFAULT;